import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Header from '../../components/Header'
import { collection, query, where, getDocs, addDoc } from 'firebase/firestore'
import { db } from '../../backend/firebase'
import './AddCollection.css'

const AddCollection = () => {
  const { uid } = useParams()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    collectionName: '',
    description: '',
    isPrivate: false
  })

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const trimmedName = formData.collectionName.trim()
    const trimmedDescription = formData.description.trim()

    if (!trimmedName) return

    let collectionsRef
    let q

    if (formData.isPrivate) {
      collectionsRef = collection(db, "Users", uid, "collections")
      q = query(collectionsRef, where("collectionName", "==", trimmedName))
    } else {
      collectionsRef = collection(db, "collections")
      q = query(collectionsRef, where("collectionName", "==", trimmedName))
    }

    const querySnapshot = await getDocs(q)

    if (!querySnapshot.empty) {
      alert("A collection with this name already exists.")
      return
    }

    await addDoc(collectionsRef, {
      collectionName: trimmedName,
      description: trimmedDescription,
      isPrivate: formData.isPrivate,
      createdAt: new Date(),
      uid: uid
    })

    navigate(-1)
  }

  return (
    <div className="add-collection-container">
      <div className="add-collection-content">
        <h2 className="add-collection-title">Create New Collection</h2>
        <form onSubmit={handleSubmit} className="add-collection-form">
          <div className="form-group">
            <label htmlFor="collectionName" className="form-label">
              Collection Name *
            </label>
            <input
              type="text"
              id="collectionName"
              name="collectionName"
              value={formData.collectionName}
              onChange={handleInputChange}
              required
              className="form-input"
            />
          </div>
          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description
            </label>
            <textarea
              id="description"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              className="form-textarea"
            />
          </div>
          <div className="privacy-section">
            <label className="privacy-label">
              Privacy Setting:
            </label>
            <div className="privacy-buttons">
              <button
                type="button"
                onClick={() => setFormData({...formData, isPrivate: false})}
                className={`privacy-button ${!formData.isPrivate ? 'privacy-button-active' : 'privacy-button-inactive'}`}
              >
                Public
              </button>
              <button
                type="button"
                onClick={() => setFormData({...formData, isPrivate: true})}
                className={`privacy-button ${formData.isPrivate ? 'privacy-button-active' : 'privacy-button-inactive'}`}
              >
                Private
              </button>
            </div>
          </div>

          <button
            type="submit"
            className={`submit-button ${formData.collectionName && formData.description ? 'submit-button-active' : 'submit-button-inactive'}`}
          >
            Create <b>{formData.isPrivate ? "Private" : "Public"}</b> Collection
          </button>
        </form>
      </div>
    </div>
  )
}

export default AddCollection